import { createApiSlice } from "@common/common-slice/commonSlice";

import {
  CRUD_SKILL_ASSESSMENT,
  GET_ARCHIEVED_SKILL_ASSESSMENT,
  GET_ASSESSMENT_DETAILS,
  PUBLISH_SKILL_ASSESSMENT,
  SKILL_ASSESSMENT_PREVIEW,
  SKILL_ASSESSMENT_PREVIEW_RESPONSE
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addSkillAssessment",
    method: "post",
    url: CRUD_SKILL_ASSESSMENT,
    stateKey: "message",
  },
  {
    name: "publishSkillAssessment",
    method: "post",
    url: PUBLISH_SKILL_ASSESSMENT,
    stateKey: "message",
  },
  {
    name: "getSkillAssessment",
    method: "get",
    url: CRUD_SKILL_ASSESSMENT,
    stateKey: "data",
  },
  {
    name: "getArchievedSkillAssessment",
    method: "get",
    url: GET_ARCHIEVED_SKILL_ASSESSMENT,
    stateKey: "data",
  },
  {
    name: "getAssessmentDetails",
    method: "get",
    url: GET_ASSESSMENT_DETAILS,
    stateKey: "details",
  },
  {
    name: "updateSkillAssessmentArchieve",
    method: "put",
    url: CRUD_SKILL_ASSESSMENT,
    stateKey: "message",
  },
  {
    name: "updateSkillAssessment",
    method: "put",
    url: CRUD_SKILL_ASSESSMENT,
    stateKey: "message",
  },
  {
    name: "deleteSkillAssessment",
    method: "delete",
    url: CRUD_SKILL_ASSESSMENT,
    stateKey: "message",
  },

  // skill assessment preview
  {
    name: "getSkillAssessmentPreview",
    method: "get",
    url: SKILL_ASSESSMENT_PREVIEW,
    stateKey: "skillAssessmentPreviewData",
  },
  {
    name: "addPreviewResponse",
    method: "post",
    url: SKILL_ASSESSMENT_PREVIEW_RESPONSE,
    stateKey: "data",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    additionalData: [],
    searchAssessmentData: "",
    allAssessmentData: [],
    genData: [],
    alertData: [],
    details: [],
    skillAssessmentPreviewData: []
  },
  reducers: {
    setAllAssessment: (state, action) => {
      state.allAssessmentData = action?.payload;
      state.data = action?.payload;
    },
    setAssessment: (state, action) => {
      state.data = action?.payload;
    },  
    setAssessmentSearchTerm: (state, action) => {
      state.searchAssessmentData = action?.payload;
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "skillAssessment",
  apiConfig,
  customReducers
);
const skillAssessmentSlice = slice;
// Export the slice's reducer
export default skillAssessmentSlice.reducer;

// Dynamically export all actions
export const actionsExports = actions;

// Destructure and export thunks directly from thunksExports
export const {
  getSkillAssessmentPreview,
  addSkillAssessment,
  publishSkillAssessment,
  getSkillAssessment,
  getAssessmentDetails,
  getArchievedSkillAssessment,
  updateSkillAssessment,
  updateSkillAssessmentArchieve,
  deleteSkillAssessment,
  addPreviewResponse
} = thunks;

// Destructure and export actions directly from actionsExports
export const {
  rowSelect,
  setAssessmentSearchTerm,
  setAllAssessment,
  setAssessment,
} = actionsExports;
